import React from "react";
import Home from "./components/Home";
import News from "./components/News";
import Estates from "./components/Estates";
import Pillars from "./components/Pillars";
import AboutUs from "./components/AboutUs";
import Error404 from "./components/Error404";
import Checkout from "./components/Checkout";
import Projects from "./components/Projects";
import Auctions from "./components/Auctions";
import Structure from "./components/Structure";
import ContactUs from "./components/ContactUs";
import NewsDetail from "./components/NewsDetail";
import Renovations from "./components/Renovations";
import EstateDetail from "./components/EstateDetail";
import ProjectDetail from "./components/ProjectDetail";
import AuctionDetail from "./components/AuctionDetail";
import RenovationDetail from "./components/RenovationDetail";
import {BrowserRouter, Route, Switch} from "react-router-dom";

class App extends React.Component {
    render() {
        return (
            <BrowserRouter>
                <Switch>
                    <Route exact path="/" component={Home}/>
                    <Route exact path="/pages/news" component={News} />
                    <Route exact path="/checkout" component={Checkout} />
                    <Route exact path="/pages/pillars" component={Pillars} />
                    <Route exact path="/pages/about-us" component={AboutUs} />
                    <Route exact path="/pages/structure" component={Structure} />
                    <Route exact path="/projects/:status" component={Projects} />
                    <Route exact path="/renovations/:status" component={Renovations} />
                    <Route exact path="/auctions/:status" component={Auctions} />
                    <Route exact path="/pages/contact-us" component={ContactUs} />
                    <Route exact path="/news-detail/:slug" component={NewsDetail} />
                    <Route exact path="/auction-detail/:id" component={AuctionDetail} />
                    <Route exact path="/project-detail/:id" component={ProjectDetail} />
                    <Route exact path="/renovation-detail/:id" component={RenovationDetail} />
                    <Route exact path="/estate-detail/:id" component={EstateDetail}/>
                    <Route exact path="/estates" component={Estates} />
                    <Route component={Error404} />
                </Switch>
            </BrowserRouter>
        );
    }
}

export default App;
